import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "../lib/api";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { OurSalon, PackagesSection, Testimonials } from "../components/site/HomeSections";
import { ServicesSection, GallerySection } from "../components/site/ServicesGallery";
import { AcademySection, AboutSection } from "../components/site/AcademyAbout";
import { BookingSection, LocationSection, Footer } from "../components/site/BookingContact";

export default function Home() {
  const [services, setServices] = useState([]);
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1 });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    api.get("/services").then(({ data }) => setServices(data)).catch(() => {});
    api.get("/staff").then(({ data }) => setStaff(data)).catch(() => {});
    return () => lenis.destroy();
  }, []);

  const courses = services.filter((s) => s.category === "Academy");
  const packages = services.filter((s) => s.category === "Packages");
  const bookable = services.filter((s) => s.category !== "Academy");

  return (
    <div className="bg-[#FAFAF8] text-left" data-testid="home-page">
      <Navbar />
      <Hero />
      <OurSalon />
      <ServicesSection services={services} />
      <PackagesSection packages={packages} />
      <GallerySection />
      <AcademySection courses={courses} />
      <Testimonials />
      <AboutSection />
      <BookingSection services={bookable} staff={staff} />
      <LocationSection />
      <Footer />
    </div>
  );
}
